enum ReportType
{
  None,
  Valuation
}

export default ReportType